module.exports = __webpack_public_path__ + "media/images/vp/bg.authcols.title-1e736dea72b1829db675d7c1e2a5cb66.svg";